// extracted by mini-css-extract-plugin
export default {"hubtrainings":"HubTrainings_hubtrainings__LmKh-","imgPart":"HubTrainings_imgPart__lXSdX","textPart":"HubTrainings_textPart__7EgR3"};